import { useEffect, useState } from "react"
import ReactApexChart from "react-apexcharts"
import axios from "axios"

import BACKEND_URL from "../../../api"

const ChartSix = ({ year }) => {
  const userid = sessionStorage.getItem("userid")
  const thisYear = new Date().getFullYear()

  const [state, setState] = useState({
    series: [
      {
        name: "Total Shipments",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
    ],
  })
  const [options, setOptions] = useState({
    legend: {
      show: true,
      position: "top",
      horizontalAlign: "left",
    },
    colors: ["#3C50E0", "#80CAEE"],
    chart: {
      fontFamily: "Satoshi, sans-serif",
      height: 335,
      type: "line",
      dropShadow: {
        enabled: true,
        color: "#623CEA14",
        top: 10,
        blur: 4,
        left: 0,
        opacity: 0.1,
      },
      toolbar: {
        show: false,
      },
    },
    responsive: [
      {
        breakpoint: 1024,
        options: {
          chart: {
            height: 300,
          },
        },
      },
    ],
    stroke: {
      width: 3,
      curve: "smooth",
    },
    grid: {
      xaxis: {
        lines: {
          show: true,
        },
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    markers: {
      size: 4,
      colors: "#fff",
      strokeColors: ["#3056D3", "#80CAEE"],
      strokeWidth: 3,
      strokeOpacity: 0.9,
      strokeDashArray: 0,
      fillOpacity: 1,
      discrete: [],
      hover: {
        size: undefined,
        sizeOffset: 5,
      },
    },
    xaxis: {
      type: "category",
      categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    title: {
      text: "Total Shipments",
      align: "center",
    },
    yaxis: {
      title: {
        style: {
          fontSize: "0px",
        },
      },
    },
  })

  useEffect(() => {
    if (year == 0) {
      // Create a new options object to avoid mutating the existing state
      const newOptions = {
        ...options,
        xaxis: {
          ...options.xaxis,
          categories: [],
        },
      }

      // Populate categories with years from 2021 to thisYear
      for (let i = 2021; i <= thisYear; i++) {
        newOptions.xaxis.categories.push(i)
      }

      // Update the state with the new options
      setOptions(newOptions)
    } else {
      const newOptions = {
        ...options,
        xaxis: {
          ...options.xaxis,
          categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        },
      }
      setOptions(newOptions)
    }

    axios
      .post(
        `${BACKEND_URL}/getMonthlyShipments`,
        {
          thisYear: year,
          userid: userid,
        },
        {},
      )
      .then((res) => {
        console.log("getMonthlyShipments------------", res.data)

        const newState = {
          ...state,
          series: [{ ...state.series[0], data: [] }],
        }
        res.data.forEach((item) => {
          newState.series[0].data.push(item.totalShipments)
        })
        setState(newState)
      })
      .catch((err) => console.log(err))
  }, [year])

  return (
    <div
      style={{
        margin: "10px 10px 20px 20px",
        borderRadius: "12px",
        border: "1px solid #E5E7EB",
        backgroundColor: "white",
        paddingTop: "10px",
      }}
    >
      <div>
        <div id="chartOne" className="-ml-5">
          <ReactApexChart options={options} series={state.series} type="line" height={350} />
        </div>
      </div>
    </div>
  )
}

export default ChartSix
